import { render, staticRenderFns } from "./groupManager.vue?vue&type=template&id=52f1fcc4&"
import script from "./groupManager.vue?vue&type=script&lang=js&"
export * from "./groupManager.vue?vue&type=script&lang=js&"
import style0 from "./groupManager.vue?vue&type=style&index=0&id=52f1fcc4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports